import { Button, useTheme } from '@mui/material';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  selection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid #fff`,
    flex: '1 1 auto',
    '&:hover': {
      boxShadow: `0px 0px 5px 0 ${theme.palette.primary.main}`,
    },
  },
  container: {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
    alignItems: 'stretch',
    justifyContent: 'center',
  },
  label: {
    display: 'flex',
    flex: '1 1 auto',
    height: '100%',
    width: '8em',
    color: '#d1cfcf',
    margin: '1em',
    fontSize: '12px',
    textTransform: 'initial',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export interface SelectionComponentProps {
  handleClick: (answer: string | boolean) => void;
  id: string;
  answers: {
    title: string;
    key: string | boolean;
  }[];
}

const SelectionComponent: React.FC<SelectionComponentProps> = ({ handleClick, id, answers }) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const [selected, setSelected] = React.useState<string | boolean | null>(null);

  return (
    <div className={classes.container}>
      {answers.map((answer) => (
        <Button
          id={`btn_wizard_${id}_${answer.key}`}
          key={`${id}-${answer.title}`}
          name={`${id}-${answer.title}`}
          className={classes.selection}
          style={{
            borderColor:
              answer.key && answer.key === selected ? theme.palette.primary.main : '#fff',
          }}
          onClick={() => {
            setSelected(answer.key);
            handleClick(answer.key);
          }}
        >
          <div className={classes.label}>{answer.title}</div>
        </Button>
      ))}
    </div>
  );
};

export default SelectionComponent;
